export default "<p>clientreport works!</p>\n";